/**
 * Composant de bouton de catégorie pour l'interface du quiz
 * Affiche les statistiques d'une catégorie (Histoire par défaut)
 */
import "../styles/setting.css";
import "../styles/best_score.css";

/**
 * BoutonCat - Composant d'affichage de catégorie de quiz
 * @param {Object} props - Les propriétés du composant
 * @param {string} props.className - Classes CSS additionnelles pour le style
 * @returns {JSX.Element} Carte de catégorie avec statistiques
 */
export const BestScore = ({ className, bestCat, bestScore }) => {
    return (
        <div className={`best-score ${className}`}>
            <div className="best-score-title">
                <p className="best-score-title-p">Votre meilleur score</p>
            </div>

            <div className="best-score-inf">
                <div className="best-score-inf-cat">
                    <p className="best-score-inf-cat-p">{bestCat}</p>
                </div>
                <div className="best-score-inf-score">
                    <p className="best-score-inf-score-p">{bestScore}</p>
                    <p className="best-score-inf-score-txt">pts</p>
                </div>
            </div>
        </div>
    );
};
